import { render } from "./menu-online.vue?vue&type=template&id=c4fa9000&scoped=true&bindings={\"name\":\"data\",\"copyMessage\":\"data\",\"generateName\":\"options\",\"submit\":\"options\"}"
import script from "./menu-online.vue?vue&type=script&lang=js"
export * from "./menu-online.vue?vue&type=script&lang=js"

import "./menu-online.vue?vue&type=style&index=0&id=c4fa9000&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c4fa9000"

export default script